export default function Icon({ name, size = 24, className = "", style = {} }) {
  return (
    <span
      className={`material-symbols-outlined ${className}`}
      style={{ fontSize: size, lineHeight: 1, userSelect: "none", ...style }}
    >
      {name}
    </span>
  );
}
